import React from 'react'
import PropTypes from 'prop-types'
import Logo from 'js/components/Logo'
import Button from 'js/components/Button/Button'
import useBreakpoints from 'js/hooks/useBreakpoints'
import { Link } from 'react-router-dom'
import AppButtons from 'js/components/AppButtons/AppButtons'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import bubbleLeft from './assets/bubble-left.png'
import bubbleRight from './assets/bubble-right.png'

function MealPlansPageHeader({
  nativeAd,
  backgroundStyles,
  defaultLayout = true,
  screenshot,
  heading,
  buttonText = <FormattedMessage {...messages.start_meal_plan} />,
  buttonLink = '/signup',
  firstSectionBackground = 'bg-white',
  ...props
}) {
  const { LG } = useBreakpoints()

  return (
    <div className={firstSectionBackground}>
      <header className="relative overflow-hidden" style={backgroundStyles}>
        <div className="relative z-10 mx-auto flex w-full max-w-1024 justify-center px-32 pt-24 lg:justify-start lg:pt-32 xxl:max-w-1280">
          <Logo inverted className="mb-32" />
        </div>
        <section className="relative z-10 mx-auto flex w-full max-w-1024 justify-center px-32 lg:justify-between xxl:max-w-1280">
          <div>
            <h1 className="type-large-plus mb-24 text-center text-white lg:mb-0 lg:py-36 lg:text-left">
              {heading}
            </h1>
            {nativeAd ? (
              <div className="text-center lg:text-left">
                <AppButtons />
              </div>
            ) : (
              <div className="mx-auto mb-32 md:flex md:max-w-512 lg:mb-96 lg:block lg:max-w-none">
                <Button
                  color="white"
                  big
                  className="mb-16 md:mx-8 lg:mb-0 lg:ml-0 lg:mr-24"
                  block={!LG}
                  use="a"
                  href="#start"
                >
                  <FormattedMessage {...messages.learn_more} />
                </Button>
                <Button
                  color="white"
                  className="md:mx-8 lg:mx-0"
                  outline
                  big
                  block={!LG}
                  use={Link}
                  to={buttonLink}
                >
                  {buttonText}
                </Button>
              </div>
            )}
          </div>
          {defaultLayout && screenshot && (
            <div className="shrink-0 lg:ml-40 xxl:ml-256">
              <div
                style={{
                  height: '400px',
                  width: '300px',
                  position: 'relative',
                }}
                className="hidden lg:block"
              >
                <div>
                  <img src={screenshot} alt="" />
                  <img
                    src={bubbleLeft}
                    alt=""
                    className="absolute"
                    width="152"
                    style={{ left: '-60px', top: '214px' }}
                  />
                  <img
                    src={bubbleRight}
                    alt=""
                    className="absolute"
                    width="152"
                    style={{ right: '-72px', top: '133px' }}
                  />
                </div>
              </div>
            </div>
          )}
        </section>
        {props.children}
      </header>
    </div>
  )
}

MealPlansPageHeader.propTypes = {
  nativeAd: PropTypes.bool.isRequired,
  backgroundStyles: PropTypes.object.isRequired,
  heading: PropTypes.any.isRequired,
  buttonText: PropTypes.any,
  buttonLink: PropTypes.string,
  children: PropTypes.any,
  defaultLayout: PropTypes.bool,
  screenshot: PropTypes.string,
  firstSectionBackground: PropTypes.string,
}

export default MealPlansPageHeader
